// import React, { useCallback, useEffect, useState } from 'react';
// import { Toast, ToastBody, ToastHeader } from 'reactstrap';
// import { logOut } from '../../utils/logOut';

// const SessionTimer = () => {
//     const [showWarning, setShowWarning] = useState(false);
//     // const [timeLeft, setTimeLeft] = useState(null);
//     const [countdownTime, setCountdownTime] = useState({
//         minutes: 0,
//         seconds: 0
//     });
//     const [isMinimized, setIsMinimized] = useState(false);
//     const [isLoggingOut, setIsLoggingOut] = useState(false);

//     const handleLogout = useCallback(() => {
//         if (isLoggingOut) return; // Prevent multiple logouts
//         setIsLoggingOut(true);
//         logOut(() => window.location.href = '/login');
//     }, [isLoggingOut]);

//     useEffect(() => {
//         const checkExpiration = () => {
//             if (isLoggingOut) return; // Skip check if already logging out

//             const expirationTimestamp = Number(localStorage.getItem("expiratDate"));
//             if (!expirationTimestamp) return;

//             const now = new Date().getTime();
//             const timeUntilExpiry = expirationTimestamp - now;
//             const fiveMinutes = 5 * 60 * 1000;

//             if (timeUntilExpiry <= fiveMinutes && timeUntilExpiry > 0) {
//                 setShowWarning(true);
//                 // setTimeLeft(Math.ceil(timeUntilExpiry / 1000 / 60));
//                 setCountdownTime({
//                     minutes: Math.floor(timeUntilExpiry / 1000 / 60),
//                     seconds: Math.floor((timeUntilExpiry / 1000) % 60)
//                 });
//             } else if (timeUntilExpiry <= 0) {
//                 handleLogout();
//             }
//         };

//         const timer = setInterval(checkExpiration, 1000);
//         checkExpiration(); // Initial check

//         return () => clearInterval(timer);
//     }, [handleLogout, isLoggingOut]);

//     if (!showWarning) return null;

//     return (
//         <div style={{
//             position: 'fixed',
//             bottom: '20px',
//             right: '20px',
//             zIndex: 1050,
//             maxWidth: '300px',
//         }}>
//             <Toast isOpen={showWarning}>
//                 <ToastHeader icon="danger" style={{ position: 'relative' }}>
//                     {isMinimized ? (
//                         <>{String(countdownTime.minutes).padStart(2, '0')}:
//                             {String(countdownTime.seconds).padStart(2, '0')}</>
//                     ) : (
//                         <>Oturum Süresi Dolmak Üzere!</>
//                     )}
//                     <button
//                         onClick={() => setIsMinimized(!isMinimized)}
//                         style={{
//                             position: 'absolute',
//                             right: '10px',
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             background: 'none',
//                             border: 'none',
//                             cursor: 'pointer',
//                             padding: '5px',
//                             fontSize: '16px',
//                             color: '#6c757d'
//                         }}
//                     >
//                         {isMinimized ?
//                             <i className="icofont icofont-plus" /> :
//                             <i className="icofont icofont-minus" />
//                         }
//                     </button>
//                 </ToastHeader>
//                 <ToastBody style={{
//                     maxHeight: isMinimized ? '0' : '500px',
//                     overflow: 'hidden',
//                     transition: 'max-height 0.3s ease-in-out',
//                     padding: isMinimized ? '0' : '0.75rem'
//                 }}>
//                     <div className="mb-2">
//                         Oturumunuz sonlanmadan kalan süre:{' '}
//                         <strong>
//                             {String(countdownTime.minutes).padStart(2, '0')}:
//                             {String(countdownTime.seconds).padStart(2, '0')}
//                         </strong>
//                     </div>
//                     <div className="text-muted mb-2">
//                         Lütfen değişikliklerinizi kaydedin.
//                     </div>
//                 </ToastBody>
//             </Toast>
//         </div>
//     );
// };

// export default SessionTimer;


import devices from 'devextreme/core/devices';
import Cookies from 'js-cookie';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import { logOut } from '../../utils/logOut';
const IsLoggedIn = ({ history }) => {
    var isMobile = devices.current().deviceType === 'phone';
    const [showWarning, setShowWarning] = useState(false);
    const [countdownTime, setCountdownTime] = useState({
        minutes: 0,
        seconds: 0
    });
    const [isMinimized, setIsMinimized] = useState(
        isMobile ? true : false
    );
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const location = useLocation();

    const checkAuthStatus = useCallback(() => {
        const user = localStorage.getItem("user");
        const token = Cookies.get("token");
        const fullName = localStorage.getItem("fullName");
        const roles = localStorage.getItem("roles");

        // If we're on the login page
        if (location.pathname === "/login") {
            if (user && token && fullName && roles) {
                history.push("/index");
            }
        }
        // If we're on any other page
        else {
            if (!user || !token || !fullName || !roles) {
                history.push("/login");
            }
        }
    }, [history, location.pathname]);

    const handleLogout = useCallback(() => {
        if (isLoggingOut) return; // Prevent multiple logouts
        setIsLoggingOut(true);

        logOut(() => history.push('/login'));
    }, [isLoggingOut, history]);

    useEffect(() => {
        // Check auth status on mount and pathname change
        checkAuthStatus();

        const checkExpiration = () => {

            if (isLoggingOut) return;

            const expirationTimestamp = Number(localStorage.getItem("expiratDate"));
            if (!expirationTimestamp) return;

            const now = new Date().getTime();
            const timeUntilExpiry = expirationTimestamp - now;
            const fiveMinutes = 5 * 60 * 1000;

            if (timeUntilExpiry <= fiveMinutes && timeUntilExpiry > 0) {
                setShowWarning(true);
                setCountdownTime({
                    minutes: Math.floor(timeUntilExpiry / 1000 / 60),
                    seconds: Math.floor((timeUntilExpiry / 1000) % 60)
                });
            } else if (timeUntilExpiry <= 0) {
                handleLogout();
            }
        };

        const timer = setInterval(() => {
            checkAuthStatus();
            checkExpiration();
        }, 1000);

        // Initial checks
        checkExpiration();

        return () => clearInterval(timer);
    }, [handleLogout, isLoggingOut, checkAuthStatus]);

    if (!showWarning) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1050,
            width: isMinimized ? '130px' : '300px'
        }}>
            <Toast isOpen={showWarning}>
                <ToastHeader icon="danger" style={{ position: 'relative' }}>
                    {isMinimized ? (
                        <>{String(countdownTime.minutes).padStart(2, '0')}:
                            {String(countdownTime.seconds).padStart(2, '0')}</>
                    ) : (
                        <>Oturum Süresi Dolmak Üzere!</>
                    )}
                    <button
                        onClick={() => setIsMinimized(!isMinimized)}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '5px',
                            fontSize: '16px',
                            color: '#6c757d'
                        }}
                    >
                        {isMinimized ?
                            <i className="fa fa-plus" /> :
                            <i className="fa fa-minus" />
                        }
                    </button>
                </ToastHeader>
                <ToastBody style={{
                    maxHeight: isMinimized ? '0' : '500px',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out',
                    padding: isMinimized ? '0' : '0.75rem'
                }}>
                    <div className="mb-2">
                        Oturumunuz sonlanmadan kalan süre:{' '}
                        <strong>
                            {String(countdownTime.minutes).padStart(2, '0')}:
                            {String(countdownTime.seconds).padStart(2, '0')}
                        </strong>
                    </div>
                    <div className="text-muted mb-2">
                        Lütfen değişikliklerinizi kaydedin.
                    </div>
                </ToastBody>
            </Toast>
        </div>
    );
};

export default IsLoggedIn;